import axios from 'axios'
import { handleApiError } from '@/utils/apiHelpers'
export default {
    getNCFJobsReports({ commit }, {
        paginate = '',
        query = ''
    } = {}) {
        commit('GET_NCF_JOBS_REPORTS_REQUEST')

        return axios
            .get(`/reports/report-jobs${paginate}${query}`)
            .then(response => {
                commit('GET_NCF_JOBS_REPORTS_SUCCESS', response.data)

                return Promise.resolve(response)
            })
            .catch(error => {
                commit('GET_NCF_JOBS_REPORTS_FAILURE')
                handleApiError(error, 'Pobranie zleceń NCF nie powiodło się.')

                return Promise.reject(error)
            })
    },
    clearNCFJobsReports({ commit }) {
        commit('CLEAR_NCF_JOBS_REPORTS')
    },
    setNCFJobsReportsFilters({ commit }, filters) {
        commit('SET_NCF_JOBS_REPORTS_FILTERS', filters)
    },
    generateNCFJobsReportsReport({ commit }, {
        query = '',
        userEmail
    } = {}) {
        return axios
            .get(`/reports/report-jobs?report=true${query}`, {
                timeout: 120000, // 2 min
            })
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: `Raport został wysłany na adres ${userEmail}.`
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    generateJobProductsReport({ commit }, jobProductsReportData) {
        return axios
            .post('reports/report-jobs-products', jobProductsReportData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: `Raport został wysłany na adres ${jobProductsReportData['userEmail']}.`
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
    generateJobPartsReport({ commit }, jobPartsReportData) {
        return axios
            .post('reports/report-jobs-parts', jobPartsReportData)
            .then(response => {
                commit('SHOW_NOTIFICATION', {
                    type: 'success',
                    message: `Raport zostanie wysłany na adres ${jobPartsReportData['userEmail']}.`
                }, { root: true })

                return Promise.resolve(response)
            })
            .catch(error => {
                handleApiError(error, 'Wygenerowanie raportu nie powiodło się.')

                return Promise.reject(error)
            })
    },
}